// extracted by mini-css-extract-plugin
module.exports = {"image":"cT","image-placeholder":"cU","imagePlaceholder":"cU"};